import { VFC } from 'react'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { truewhite, _profilegreen } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

const TagValidationModalContent: VFC<ModalProps<{ message: string }>> = ({
  message,
  close,
}) => {
  return (
    <Layout>
      <FormTitle>{message}</FormTitle>
      <ModalButtons>
        <CloseButton onClick={() => close()}>OK</CloseButton>
      </ModalButtons>
    </Layout>
  )
}

export const TagValidationModal = asModal(TagValidationModalContent)

const Layout = styled.div`
  width: 80vw;
  max-width: 400px;
  padding: 8%;
  border-radius: 10px;
  background-color: ${truewhite};
  line-height: 1.3rem;
`

const FormTitle = styled.h2`
  font-size: 19px;
  margin-bottom: 40px;
  font-weight: ${fontWeightBold};
`

const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;

  button {
    text-align: center;
    padding: 5px 21px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: ${fontWeightBold};
    line-height: 1.4;
    white-space: normal;
  }
`

const CloseButton = styled.button`
  width: 78px;
  color: ${truewhite};
  background: ${_profilegreen};
`
